export enum ProjectImportStatus {
  FINISHED = "FINISHED",
  ERROR = "ERROR"
}
